export const LOCALES = [
  {
    id: 1,
    name: 'Slovenský jazyk',
    locale: 'sk',
    image: {
      id: 1,
      name: 'sk.svg',
      url: 'https://api.svetech.sk/files/sk.svg?ai=0',
      description: null,
      custom_title: 'sk',
      alt: 'sk',
      alt_locale: null,
      is_decorative: false,
      metadata: null,
      is_ai_generated: false,
    },
    is_default: true,
  },
];
